// Libs
import { IconButton, Input, InputAdornment } from '@mui/material';
import { Button, Link, Logo, LogoIcon } from 'components';
import { PersonIcon } from 'components/Icons';
import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { useUserApi } from 'hooks';
import { withStyles } from '@mui/styles';
import useTheme from 'hooks/useTheme';

import GENERAL from 'utils/constants/general';
import { sendToast } from 'screens/Dashboard/actions';

// style
import styles from './RecoveryPassword.module.css';
const { ENV } = GENERAL;

const customStyles = () => ({
	button: {
		top: '10px',
		fontFamily: 'Roboto',
	},
	textField: {
		width: '100%',
		maxWidth: '320px',
		minHeight: '48px',
		height: '48px',
		paddingLeft: '15px',
		backgroundColor: 'rgba(255,255,255,.07)',
		color: '#fff',
		fontFamily: 'Roboto',
	},
	icon: {
		color: 'rgba(255, 255, 255, 0.54)',
	},
});

const initialState = {
	isLoading: false,
	idc: '',
	colorInput: 'info',
	hasSubmitted: false,
};

const RecoveryPassword = ({ classes, sendToast }) => {
	const { theme } = useTheme();
	const inputRef = useRef(null);
	const { recoveryPasswordRequest } = useUserApi();
	const [state, setState] = useState(initialState);
	const isSuccess = state.hasSubmitted;

	useEffect(() => {
		if (state.hasSubmitted) {
			sendToast({
				message:
					'Si el usuario existe, enviamos un enlace seguro al correo registrado.',
				type: 'success',
			});
			return;
		}

		sendToast({
			message:
				'Ingrese su usuario para enviar un enlace seguro de recuperación.',
		});
		setTimeout(() => {
			inputRef?.current?.focus();
		}, 100);
	}, [state.hasSubmitted]);

	const onChange = e =>
		setState(prev => ({
			...prev,
			[e.target.name]: e.target.value?.trim(),
			colorInput: 'info',
		}));

	const onClick = async () => {
		if (!state.idc) {
			sendToast({
				message: 'Ingrese su usuario.',
				type: 'warning',
			});
			setState(prev => ({ ...prev, colorInput: 'error' }));
			inputRef?.current?.focus();
			return;
		}

		try {
			setState(prev => ({ ...prev, isLoading: true }));
			await recoveryPasswordRequest(state.idc);
			setState(prev => ({
				...prev,
				isLoading: false,
				hasSubmitted: true,
				colorInput: 'info',
			}));
		} catch (err) {
			sendToast({
				message: err.message,
				type: 'error',
			});
			setState(prev => ({
				...prev,
				isLoading: false,
				colorInput: 'error',
			}));
			inputRef?.current?.focus();
		}
	};

	return (
		<div>
			<div className={`${styles.card} ${isSuccess ? styles.cardSuccess : ''}`}>
				<Logo position='absolute' left='100px' top='-55px' opacity='.7' />

				<div className={styles.content}>
					<div className={styles.header}>
						{isSuccess && (
							<span className={styles.statusPill}>Solicitud enviada</span>
						)}
						<h2 className={styles.title}>
							{isSuccess ? 'Revise su correo' : 'Recuperar contraseña'}
						</h2>
						<p className={styles.message}>
							{isSuccess
								? 'Hemos procesado su solicitud. Si el usuario existe en la plataforma, enviaremos un enlace seguro al correo registrado. Revise su bandeja de entrada y también la carpeta de spam o correo no deseado.'
								: 'Ingrese su usuario para recibir un enlace seguro de recuperación de contraseña en su correo registrado.'}
						</p>
					</div>

					{!isSuccess && (
						<div className={styles.inputWrapper}>
							<Input
								style={{
									color: theme._mediumEmphasisColor,
								}}
								inputRef={inputRef}
								color={state.colorInput}
								className={classes.textField}
								name='idc'
								placeholder='Usuario'
								disabled={isSuccess}
								onChange={onChange}
								value={state.idc}
								type='text'
								endAdornment={
									<InputAdornment position='end'>
										<IconButton>
											<PersonIcon className={classes.icon} />
										</IconButton>
									</InputAdornment>
								}
							/>
						</div>
					)}
				</div>

				{(!isSuccess || state.isLoading) && (
					<div className={styles.footer}>
						<div className={styles.actions}>
							{state.isLoading ? (
								<LogoIcon spin />
							) : (
								<Button onClick={onClick}>Enviar enlace</Button>
							)}
						</div>

						<div className={styles.footerLinks}>
							<span className={styles.footerText}>¿Ya tiene cuenta?</span>
							<Link style={{ color: '#1890ff' }} to={ENV.ROUTES.PATHS.LOGIN}>
								Ingresar
							</Link>
						</div>
					</div>
				)}
			</div>
		</div>
	);
};
const actions = { sendToast };

export default connect(
	null,
	actions,
)(withStyles(customStyles)(RecoveryPassword));
